import { getHistoryBackDelta, history } from "@dashboard/components/Router";
import { useCallback } from "react";

import { usePopupBack } from "./usePopupBack";

// 상단 ← · 하단 '뒤로' 버튼의 뒤로가기 (2026-11-03 KST 추가).
// 페이지가 넘겨준 상위 주소(목록 등) 대신, 이 창에서 지나온 직전 페이지가 있으면 그리로 돌아간다.
// 예) 메뉴 수정 → 메뉴 항목 '보기' → 카테고리 수정 에서 ← 는 카테고리 목록이 아니라 메뉴 수정으로 간다.
// 직전 페이지가 없으면(주소를 직접 열었거나 새로고침) false 를 돌려주어 원래 상위 주소로 가게 둔다.
// 상세 팝업 창은 usePopupBack 의 동작(처음 페이지는 창 닫기)을 그대로 따른다.
export const usePageBack = (): (() => boolean) => {
  const popupBack = usePopupBack();

  return useCallback((): boolean => {
    if (popupBack()) {
      return true;
    }

    const delta = getHistoryBackDelta();

    if (delta === null) {
      return false;
    }

    history.go(delta);

    return true;
  }, [popupBack]);
};
